module.exports = __webpack_public_path__ + "static/media/TerryAndClaire-3.3331bbc7.png";